(function (){
    'use strict';

    angular
        .module('services')
        .service('AudienceService', AudienceService);

    //$httpParamSerializer

    AudienceService.$inject = ['$http', 'API_BASE'];

    function AudienceService ($http, API_BASE) {
        var service = this;
        service.editAudience       = editAudience;
        service.saveAudience       = saveAudience;
        service.getAudience        = getAudience;
        service.getAllAudiences    = getAllAudiences;
        service.getAudiences       = getAudiences;
        service.deleteAudience     = deleteAudience;
        service.updateAudience     = updateAudience;
        service.calculateAudience  = calculateAudience;


        function editAudience (query) {
            return $http.get(API_BASE + '/email/audiences/edit',{params:query});
        }

        function saveAudience (query) {
            return $http.post(API_BASE + '/email/audience/save',JSON.stringify(query));
        }

        function getAudience () {
            return $http.get(API_BASE + '/email/audience/list');
        }

        function getAllAudiences (query) {
            return $http.get(API_BASE + '/email/audiences/all',{params:query});
        }

        function getAudiences (query) {
            return $http.get(API_BASE + '/email/audiences/list',{params:query});
        }

        function deleteAudience (query) {
            return $http.get(API_BASE + '/email/audiences/delete', {params:query});
        }

        function updateAudience (query) {
            return $http.post(API_BASE + '/email/audiences/update', query);
        }

        function calculateAudience (query) {
            return $http.post(API_BASE + '/email/audiences/calculate', query);
        }

    }
})();